import React from "react";
import { PrimaryArticleCard } from "web/react/emo/primary-article-card";
import { SecondaryArticleCard } from "web/react/emo/secondary-article-card";
import { TertiaryArticleCard } from "web/react/emo/tertiary-article-card";
import { useArticleAnalytics } from "web/react/hooks/use-article-analytics/use-article-analytics";
import { ArticleCardSerializer } from "web/types/serializers";

export const ARTICLE_CARD_VARIANT = {
    primary: "primary",
    secondary: "secondary",
    tertiary: "tertiary",
};

interface InFeedArticleCardProps {
    variant: keyof typeof ARTICLE_CARD_VARIANT;
    articleProps: ArticleCardSerializer;
    analyticsComponentType: string;
}

export function InFeedArticleCard({
    variant,
    articleProps,
    analyticsComponentType,
}: InFeedArticleCardProps): React.ReactElement | null {
    const { sendClickEvent } = useArticleAnalytics({
        category: "editorial_content_card",
        itemData: [
            {
                item_type: "editorial_content_card",
                component_type: analyticsComponentType,
                editorial_label: articleProps.slug,
                franchise: articleProps.franchise || null,
                editorial_gender: articleProps.gender,
                position: articleProps.position,
                sponsored: articleProps.is_sponsored,
                content_type: articleProps.content_type || "editorial",
                is_pinned: articleProps.is_pinned,
                parent_area: "feeds",
            },
        ],
    });

    const baseProps = {
        title: articleProps.title,
        thumbnails: articleProps.thumbnails,
        is_sponsored: articleProps.is_sponsored,
        article_url: articleProps.article_url,
        onClick: sendClickEvent,
    };

    if (variant === ARTICLE_CARD_VARIANT.primary) {
        return <PrimaryArticleCard {...baseProps} caption={articleProps.caption} />;
    }

    if (variant === ARTICLE_CARD_VARIANT.secondary) {
        return <SecondaryArticleCard {...baseProps} position={articleProps.position} />;
    }

    if (variant === ARTICLE_CARD_VARIANT.tertiary) {
        return <TertiaryArticleCard {...baseProps} position={articleProps.position} />;
    }

    return null;
}
